(function () {
  'use strict';


  function assetUrl(fileName) {
    var assetUrls = window.TiltCustomizerAssetUrls || null;

    if (!assetUrls || !assetUrls[fileName]) {
      throw new Error('[TiltCustomizerRegistry] Missing Shopify asset URL for: ' + fileName);
    }

    return assetUrls[fileName];
  }

  var mousepadCanvas = { width: 2000, height: 2000 };
  var defaultCustomerImageFitOverscan = { x: 1.015, y: 1.015 };
  var matCanvas = { width: 2000, height: 2000 };
  // Cover the translucent stitching around the measured inner print areas.
  var matCustomerImageFitOverscan = { x: 1.025, y: 1.025 };
  var legacyCanvas = { width: 2500, height: 2500 };

  function cardGameTemplates() {
    return [
      ['mtg-v1', 'Magic: The Gathering'],
      ['mtg-inverted-v1', 'Magic: The Gathering (Inverted)'],
      ['starwars-v1', 'Star Wars: Unlimited'],
      ['starwars-inverted-v1', 'Star Wars: Unlimited (Inverted)'],
      ['yugioh-v1', 'Yu-Gi-Oh!'],
      ['pokemon-v1', 'Pokémon']
    ].map(function (entry) {
      return {
        id: entry[0], label: entry[1], url: assetUrl('tilt-card-template-' + entry[0] + '.webp'),
        mockTop: entry[0] === 'pokemon-v1' ? 747 : 763
      };
    });
  }

  var mousepadContextOverlayFileNames = {
    '100x50': 'tilt-customizer-mousepad-100x50-keyboard-mouse.webp',
    '90x40': 'tilt-customizer-mousepad-90x40-keyboard-mouse.webp',
    '80x30': 'tilt-customizer-mousepad-80x30-keyboard-mouse.webp',
    '50x50': 'tilt-customizer-mousepad-50x50-keyboard-mouse.webp',
    '30x30': 'tilt-customizer-mousepad-30x30-keyboard-mouse.webp'
  };

  function mousepadContextLayers(variantKey) {
    var overlayFileName = mousepadContextOverlayFileNames[variantKey];

    if (!overlayFileName) {
      throw new Error('[TiltCustomizerRegistry] Missing mousepad context overlay for variant: ' + variantKey);
    }

    return [
      layer(overlayFileName)
    ];
  }

  function mousepadContextTemplate(variantKey, printArea) {
    var baseMockup = 'tilt-customizer-mousepad-' + variantKey + '-no-keyboard.webp';

    return customTemplate('mousepad-' + variantKey, 'mousepad', printArea, [
      scene('base', 'Base', baseMockup, [], true),
      scene('context', 'Context', baseMockup, mousepadContextLayers(variantKey))
    ], 'context', mousepadCanvas, {
      customerImageFitOverscan: defaultCustomerImageFitOverscan
    });
  }

  function variantProductConfig(productType, variantId, templateKey, productId) {
    var variantIdTemplateMap = {};
    variantIdTemplateMap[String(variantId)] = templateKey;

    var config = {
      enabled: true,
      productType: productType,
      requiresCustomization: true,
      variantIdTemplateMap: variantIdTemplateMap
    };

    if (productId != null) {
      config.productId = String(productId);
    }

    return config;
  }

  function layer(fileName, placement) {
    var layerConfig = {
      fileName: fileName
    };

    if (placement) {
      layerConfig.placement = placement;
    }

    return layerConfig;
  }

  function printAreaLayer(fileName, fit, clip) {
    return layer(fileName, {
      target: 'printArea',
      fit: fit,
      clip: clip === true
    });
  }

  function resolveLayer(layerConfig) {
    if (typeof layerConfig === 'string') {
      return {
        url: assetUrl(layerConfig)
      };
    }

    if (!layerConfig || !layerConfig.fileName) {
      throw new Error('[TiltCustomizerRegistry] Scene layer fileName is required.');
    }

    return {
      url: assetUrl(layerConfig.fileName),
      placement: layerConfig.placement
    };
  }

  function scene(id, label, mockupFileName, layerFileNames, isDefault) {
    var sceneConfig = {
      id: id,
      label: label,
      mockupUrl: assetUrl(mockupFileName)
    };

    if (isDefault === true) {
      sceneConfig.default = true;
    }

    if (Array.isArray(layerFileNames) && layerFileNames.length) {
      sceneConfig.layers = layerFileNames.map(resolveLayer);
    }

    return sceneConfig;
  }

  function customTemplate(templateId, productType, printArea, scenes, contextSceneId, canvas, options) {
    if (!canvas || !canvas.width || !canvas.height) {
      throw new Error('[TiltCustomizerRegistry] Template canvas is required for: ' + templateId);
    }

    var templateConfig = {
      templateId: templateId,
      templateVersion: options && options.templateVersion || 1,
      productType: productType,
      canvas: {
        width: canvas.width,
        height: canvas.height
      },
      printArea: printArea,
      features: {
        singleArtwork: true,
        scenes: Boolean(contextSceneId)
      },
      contextSceneId: contextSceneId || null,
      scenes: scenes,
      output: {
        type: 'thumbnail',
        mimeType: 'image/webp'
      }
    };

    if (options && options.customerImageFitOverscan) {
      templateConfig.customerImageFitOverscan = options.customerImageFitOverscan;
    }

    if (options && options.cardTemplates) {
      templateConfig.cardTemplates = options.cardTemplates;
      // Full print-frame placement measured in the supplied mock overlays; see backend CardGameTemplates.
      templateConfig.cardTemplateGeometry = {
        printWidth: 7441, printHeight: 4429, border: 24,
        mockLeft: 490, mockScale: 0.14465
      };
    }

    return templateConfig;
  }

  function mousepadTemplate(variantKey, printArea) {
    return mousepadContextTemplate(variantKey, printArea);
  }

  window.TiltCustomizerTemplateRegistry = {
    productsByVariantId: {
      '48443455275342': variantProductConfig('mousepad', '48443455275342', 'mousepad-100x50-v1'),
      '48443455308110': variantProductConfig('mousepad', '48443455308110', 'mousepad-90x40-v2'),
      '48443455340878': variantProductConfig('mousepad', '48443455340878', 'mousepad-80x30-v2'),
      '48443455373646': variantProductConfig('mousepad', '48443455373646', 'mousepad-50x50-v1'),
      '48990340546894': variantProductConfig('mousepad', '48990340546894', 'mousepad-30x30-v1'),
      '60118373007694': variantProductConfig('mousepad', '60118373007694', 'mousepad-100x50-v1', '15931431780686'),
      '60118373040462': variantProductConfig('mousepad', '60118373040462', 'mousepad-90x40-v2', '15931431780686'),
      '60118373073230': variantProductConfig('mousepad', '60118373073230', 'mousepad-80x30-v2', '15931431780686'),
      '60118373105998': variantProductConfig('mousepad', '60118373105998', 'mousepad-50x50-v1', '15931431780686'),
      '60118373138766': variantProductConfig('mousepad', '60118373138766', 'mousepad-30x30-v1', '15931431780686'),
      // Business mousepads: every packaging option is a separate Shopify variant.
      '61174976414030': variantProductConfig('mousepad', '61174976414030', 'mousepad-100x50-v1', '16142207156558'),
      '61175060267342': variantProductConfig('mousepad', '61175060267342', 'mousepad-100x50-v1', '16142207156558'),
      '61175060300110': variantProductConfig('mousepad', '61175060300110', 'mousepad-100x50-v1', '16142207156558'),
      '61174976446798': variantProductConfig('mousepad', '61174976446798', 'mousepad-90x40-v2', '16142207156558'),
      '61175060332878': variantProductConfig('mousepad', '61175060332878', 'mousepad-90x40-v2', '16142207156558'),
      '61175060365646': variantProductConfig('mousepad', '61175060365646', 'mousepad-90x40-v2', '16142207156558'),
      '61174976479566': variantProductConfig('mousepad', '61174976479566', 'mousepad-80x30-v2', '16142207156558'),
      '61175060398414': variantProductConfig('mousepad', '61175060398414', 'mousepad-80x30-v2', '16142207156558'),
      '61175060431182': variantProductConfig('mousepad', '61175060431182', 'mousepad-80x30-v2', '16142207156558'),
      '61174976512334': variantProductConfig('mousepad', '61174976512334', 'mousepad-50x50-v1', '16142207156558'),
      '61175060463950': variantProductConfig('mousepad', '61175060463950', 'mousepad-50x50-v1', '16142207156558'),
      '61175060496718': variantProductConfig('mousepad', '61175060496718', 'mousepad-50x50-v1', '16142207156558'),
      '61174976545102': variantProductConfig('mousepad', '61174976545102', 'mousepad-30x30-v1', '16142207156558'),
      '61175060529486': variantProductConfig('mousepad', '61175060529486', 'mousepad-30x30-v1', '16142207156558'),
      '61175060562254': variantProductConfig('mousepad', '61175060562254', 'mousepad-30x30-v1', '16142207156558'),
      '54764673237326': variantProductConfig('card-game-mat', '54764673237326', 'card-game-mat-61-5x35-v2'),
      '54710344843598': variantProductConfig('board-game-mat', '54710344843598', 'board-game-mat-120x80-v2'),
      '54710227042638': variantProductConfig('battle-game-mat', '54710227042638', 'battle-game-mat-91-5x91-5-v2'),
      '47527344013646': variantProductConfig('floor-mat', '47527344013646', 'floor-mat-100x100-v2')
    },
    templates: {
      'mousepad-80x30-v2': customTemplate('mousepad-80x30', 'mousepad', {
        left: 471,
        top: 892,
        width: 1058,
        height: 394
      }, [
        scene('base', 'Base', 'tilt-customizer-mousepad-80x30-no-keyboard-v2.webp', [], true),
        scene('context', 'Context', 'tilt-customizer-mousepad-80x30-no-keyboard-v2.webp', [
          'tilt-customizer-mousepad-80x30-keyboard-mouse-v2.webp'
        ])
      ], 'context', mousepadCanvas, {
        templateVersion: 2,
        // The smaller mockups need enough overscan to cover translucent stitching.
        customerImageFitOverscan: { x: 1.035, y: 1.035 }
      }),
      'mousepad-90x40-v2': customTemplate('mousepad-90x40', 'mousepad', {
        left: 418,
        top: 836,
        width: 1191,
        height: 530
      }, [
        scene('base', 'Base', 'tilt-customizer-mousepad-90x40-no-keyboard-v2.webp', [], true),
        scene('context', 'Context', 'tilt-customizer-mousepad-90x40-no-keyboard-v2.webp', [
          'tilt-customizer-mousepad-90x40-keyboard-mouse.webp'
        ])
      ], 'context', mousepadCanvas, {
        templateVersion: 2,
        // The smaller mockups need enough overscan to cover translucent stitching.
        customerImageFitOverscan: { x: 1.035, y: 1.035 }
      }),
      'floor-mat-100x100-v2': customTemplate('floor-mat-100x100', 'floor-mat', {
        left: 333,
        top: 522,
        width: 1322,
        height: 1325
      }, [
        scene('base', 'Base', 'tilt-customizer-floor-mat-100x100-no-chair-v2.webp', [], true),
        scene('context', 'Context', 'tilt-customizer-floor-mat-100x100-no-chair-v2.webp', [
          'tilt-customizer-floor-mat-100x100-chair-v2.webp'
        ])
      ], 'context', matCanvas, {
        templateVersion: 2,
        customerImageFitOverscan: matCustomerImageFitOverscan
      }),
      'card-game-mat-61-5x35-v2': customTemplate('card-game-mat-61-5x35', 'card-game-mat', {
        left: 502,
        top: 775,
        width: 1052,
        height: 612
      }, [
        scene('base', 'Base', 'tilt-customizer-card-game-mat-61-5x35-none-v2.webp', [], true)
      ], null, matCanvas, {
        templateVersion: 2,
        cardTemplates: cardGameTemplates(),
        customerImageFitOverscan: matCustomerImageFitOverscan
      }),
      'battle-game-mat-91-5x91-5-v2': customTemplate('battle-game-mat-91-5x91-5', 'battle-game-mat', {
        left: 442,
        top: 531,
        width: 1127,
        height: 1131
      }, [
        scene('base', 'Base', 'tilt-customizer-battle-game-mat-91-5x91-5-none-v2.webp', [], true)
      ], null, matCanvas, {
        templateVersion: 2,
        customerImageFitOverscan: matCustomerImageFitOverscan
      }),
      'board-game-mat-120x80-v2': customTemplate('board-game-mat-120x80', 'board-game-mat', {
        left: 348,
        top: 578,
        width: 1408,
        height: 945
      }, [
        scene('base', 'Base', 'tilt-customizer-board-game-mat-120x80-none-v2.webp', [], true)
      ], null, matCanvas, {
        templateVersion: 2,
        customerImageFitOverscan: matCustomerImageFitOverscan
      }),
      'mousepad-30x30-v1': mousepadTemplate('30x30', {
        left: 743,
        top: 851,
        width: 493,
        height: 493
      }),
      'mousepad-50x50-v1': mousepadTemplate('50x50', {
        left: 658,
        top: 765,
        width: 663,
        height: 665
      }),
      'mousepad-80x30-v1': mousepadTemplate('80x30', {
        left: 327,
        top: 858,
        width: 1325,
        height: 493
      }),
      'mousepad-90x40-v1': mousepadTemplate('90x40', {
        left: 330,
        top: 803,
        width: 1319,
        height: 587
      }),
      'mousepad-100x50-v1': mousepadContextTemplate('100x50', {
        left: 329,
        top: 765,
        width: 1321,
        height: 664
      }),
      'floor-mat-100x100-v1': customTemplate('floor-mat-100x100', 'floor-mat', {
        left: 191,
        top: 184,
        width: 2122,
        height: 2134
      }, [
        scene('base', 'Base', 'tilt-customizer-floor-mat-100x100-no-chair.webp', [], true),
        scene('context', 'Context', 'tilt-customizer-floor-mat-100x100-no-chair.webp', [
          'tilt-customizer-floor-mat-100x100-chair.webp'
        ])
      ], 'context', legacyCanvas, {
        customerImageFitOverscan: defaultCustomerImageFitOverscan
      }),
      'card-game-mat-61-5x35-v1': customTemplate('card-game-mat-61-5x35', 'card-game-mat', {
        left: 338,
        top: 718,
        width: 1828,
        height: 1063
      }, [
        scene('base', 'Base', 'tilt-customizer-card-game-mat-61-5x35-none.webp', [], true)
      ], null, legacyCanvas, {
        customerImageFitOverscan: defaultCustomerImageFitOverscan
      }),
      'battle-game-mat-91-5x91-5-v1': customTemplate('battle-game-mat-91-5x91-5', 'battle-game-mat', {
        left: 313,
        top: 310,
        width: 1873,
        height: 1875
      }, [
        scene('base', 'Base', 'tilt-customizer-battle-game-mat-91-5x91-5-none.webp', [], true)
      ], null, legacyCanvas, {
        customerImageFitOverscan: defaultCustomerImageFitOverscan
      }),
      'board-game-mat-120x80-v1': customTemplate('board-game-mat-120x80', 'board-game-mat', {
        left: 154,
        top: 527,
        width: 2185,
        height: 1445
      }, [
        scene('base', 'Base', 'tilt-customizer-board-game-mat-120x80-none.webp', [], true)
      ], null, legacyCanvas, {
        customerImageFitOverscan: defaultCustomerImageFitOverscan
      })
    }
  };
}());
